import { render, staticRenderFns } from "./HouseBedSelectbox.vue?vue&type=template&id=1b29cac2&"
import script from "./HouseBedSelectbox.vue?vue&type=script&lang=js&"
export * from "./HouseBedSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports